const DIRECTION = {
  ascending: "asc",
  descending: "desc",
};

const MOVE_DIRECTION = {
  up: "UP",
  down: "DOWN",
};

export { MOVE_DIRECTION };

export default DIRECTION;
